import { useDesignMaxTheme } from "@/packages";
import { Center, Flex } from "@chakra-ui/react";
import { useState } from "react";
import { Map, MapMarker } from "react-kakao-maps-sdk";
import { SearchBox } from "./components/searchBox";
import { StoreBox } from "./components/storeBox";
import { type KakaoMapProps, type KakaoStoreProps } from "./kakaoMap.type";

export const KakaoMap = ({ latLng, name }: KakaoMapProps) => {
    const [position, setPosition] = useState(latLng);
    const [keyword, setKeyword] = useState<string>(name);
    const [markers, setMarkers] = useState<KakaoStoreProps[]>([]);
    const { COLORS, MEDIAS } = useDesignMaxTheme();

    const { isMobile } = MEDIAS();
    return (
        <Center position="relative" w="100%" h={isMobile ? "264px" : "100%"} overflow="hidden">
            <Flex
                w={isMobile ? "180px" : "360px"}
                position="absolute"
                zIndex="3"
                top="0"
                left="0"
                flexDir="column"
                gap="16px"
                m="8px 16px"
            >
                <SearchBox
                    keyword={keyword}
                    setKeyword={setKeyword}
                    position={position}
                    setPosition={setPosition}
                    setMarkers={setMarkers}
                />
                {markers.length > 0 && (
                    <Flex
                        w="100%"
                        flexDir="column"
                        gap="16px"
                        p="16px"
                        bgColor={COLORS.white}
                        borderRadius="8px"
                        maxHeight="400px"
                        overflowY="auto"
                    >
                        {markers.map(({ store }, idx) => (
                            <StoreBox key={store.id} store={store} idx={idx} setPosition={setPosition} />
                        ))}
                    </Flex>
                )}
            </Flex>
            <Map center={position} level={3} style={{ width: "100%", height: "100%" }}>
                {markers.length > 0 ? (
                    markers.map(
                        (marker) => marker.latLng && <MapMarker key={marker.latLng.lat} position={marker.latLng} />,
                    )
                ) : (
                    <MapMarker position={position} />
                )}
            </Map>
        </Center>
    );
};
